import Vue from 'vue'

export function app(name, component) {
    const node = document.querySelector(`.vue-app[vue-app=${name}]`)
    const instance = {
        name: 'App',
        render(h) {
          return h(
            'div',
            {
              attrs: {
                id: `app-${name}`
              }
            },
            [h(component)]
          )
        }
      }
    
    return new Vue(instance).$mount(node)
}